import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export type AgreementFormModel = {
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  termsAccepted: boolean;
};

export const AgreementForm: () => FormlyFieldConfig[] = () => {
  return [
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-6',
          key: 'firstName',
          type: 'input',
          props: { label: 'First name', required: true },
        },
        {
          className: 'col-6',
          key: 'lastName',
          type: 'input',
          props: { label: 'Last name', required: true },
        },
      ],
    },
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-12',
          key: 'email',
          type: 'input',
          props: { label: 'Email', disabled: true },
        },
      ],
    },
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-12',
          key: 'phone',
          type: 'input',
          validators: {
            validation: ['anyPhone'],
          },
          props: { label: 'Phone number', required: true },
        },
      ],
    },
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-12',
          key: 'termsAccepted',
          type: 'checkbox',
          wrappers: ['form-field'],
          defaultValue: false,
          validators: {
            termsAccepted: {
              expression: (c: AbstractControl) => c.value,
              message: () => 'You must accept these agreements to continue',
            },
          },
          props: {
            required: true,
            hideLabel: true,
            formCheck: 'inline',
            label:
              'I agree that Brightscrip c/o Monarch Speciality Group may send account messages to my provided phone number including SMS message for one-time PIN codes via calls, texts, or pre-recorded messages.',
          },
        },
      ],
    },
  ];
};
